module.exports = [{
      plugin: require('/Users/alex/Desktop/Gatsby_Ecommerce/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/alex/Desktop/Gatsby_Ecommerce/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
